module.exports = __webpack_public_path__ + "img/instagram.b6e7e05e.png";